import { coalColor } from "../../../styles/theme";
import { IconProps } from "./";

export const ManagementIcon = ({
  size = 16,
  color = coalColor,
  className,
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.66797 14.667C2.66797 11.7215 5.05578 9.33366 8.0013 9.33366C10.9468 9.33366 13.3346 11.7215 13.3346 14.667H2.66797ZM8.66797 10.7223V13.3337H11.7737C11.2962 11.9827 10.1136 10.9648 8.66797 10.7223ZM7.33464 13.3337V10.7223C5.88907 10.9648 4.70641 11.9827 4.22891 13.3337H7.33464ZM8.0013 8.66699C5.7913 8.66699 4.0013 6.87699 4.0013 4.66699C4.0013 2.45699 5.7913 0.666992 8.0013 0.666992C10.2113 0.666992 12.0013 2.45699 12.0013 4.66699C12.0013 6.87699 10.2113 8.66699 8.0013 8.66699ZM8.0013 7.33366C9.4749 7.33366 10.668 6.14061 10.668 4.66699C10.668 3.19337 9.4749 2.00033 8.0013 2.00033C6.52768 2.00033 5.33464 3.19337 5.33464 4.66699C5.33464 6.14061 6.52768 7.33366 8.0013 7.33366Z"
        fill={color}
        strokeWidth="0"
      />
    </svg>
  );
};
